
import { useUser } from './useUser';

export const useSpeaker = () => {
  const user = useUser();
  const speaker = JSON.parse(localStorage.getItem(`metadata_${user.username}`));
  return speaker;
};
